// extracted by mini-css-extract-plugin
export default {"shellBackdrop":"shellBackdrop--Jiftz","shellViewport":"shellViewport--r445Q","portalRoot":"portalRoot--WXZ0_"};